// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8318) return "static/chunks/8318.069806f55686db58.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"6":"bb692442727d5c64","3183":"d6bb9c152de54d4b"}[chunkId] + ".js";
};